/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlaylistOff = createReactComponent("playlist-off", "IconPlaylistOff", [
  ["path", { d: "M14 14a3 3 0 1 0 3 3", key: "svg-0" }],
  ["path", { d: "M17 13v-9h4", key: "svg-1" }],
  ["path", { d: "M13 5h-4m-4 0h-2", key: "svg-2" }],
  ["path", { d: "M3 9h6", key: "svg-3" }],
  ["path", { d: "M9 13h-6", key: "svg-4" }],
  ["path", { d: "M3 3l18 18", key: "svg-5" }]
]);

export { IconPlaylistOff as default };
//# sourceMappingURL=IconPlaylistOff.js.map
